import React from "react";
import { Header } from "./Introduce";
import styles from "../css/Artisan.css";


const app = () => {
    return (
        <div style={{ flex: 1 }}>
            <Header text="实验室介绍"></Header>
            <div className={styles.main}>
                <p className={styles.title}>
                实验室负责人
                </p>

                <div className={styles.content}>
                    <p className={styles.contentP}>
                        <img src={require("../static/韩强.jpg")}
                            style={{ width: "93px" }} className={styles.img} ></img>
                        <span style={{ "fontWeight": 600 }}>韩强 </span>  
                        ，工程师，2017年于清华大学化学系毕业获分析化学理学博士学位，2017-2020年继续在化学系从事博士后研究工作，2021年1月起在清华大学分析中心工作，主要从事分离分析应用及相关研究工作，长期致力于色谱质谱样品分析方法、样品前处理技术的开发及应用研究工作。以第一作者与合作作者发表SCI论文共40余篇，H指数20，文章引用数为1400余次（Google Scholar），其中两篇论文入选Web of Science统计的“ESI高被引论文”，入选北京市科学技术协会2021-2023年度青年人才托举工程，2021年10月份获得中国分析测试协会高校分析测试分会高校分析测试优秀青年人才奖二等奖，现任中国分析测试协会青年学术委员会委员。
                    </p>


                </div>

            </div>
        </div>
    );
};

export default app;



// WEBPACK FOOTER //
// ./src/pages/Artisan.js